var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/index.ts
import { normalize as normalizeCjk } from "normalize-cjk";
var cjkSlug = /* @__PURE__ */ __name((title, {
  lowercase = true,
  normalize = normalizeCjk
} = {}) => {
  let slug = normalize(title).replace(/[\u0022\u0027\u02bc\u0060\u00b4\u2018\u2019\u201c\u201d]/g, "").replace(/[\s_]+/g, "-").replace(/[^a-z\d\-\u3040-\u309f\u30a0-\u30ff\u3400-\u4dbf\u4e00-\u9faf\uac00-\ud7a3\uff00-\uff9f]/gi, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");
  if (lowercase) {
    slug = slug.toLowerCase();
  }
  return slug;
}, "cjkSlug");
var src_default = cjkSlug;
export {
  src_default as default
};
/*! For license information please see index.mjs.LEGAL.txt */
//# sourceMappingURL=index.mjs.map
